import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  async getProducts() {
    const response = await axios.get(`${API_URL}/products`, { headers: authHeader() });
    return response.data;
  },
  async getProduct(id) {
    const response = await axios.get(`${API_URL}/product/${id}`, { headers: authHeader() });
    return response.data;
  },
  async getProductAttributeGroups(id) {
    const response = await axios.get(`${API_URL}/product/${id}/attributeGroups`, { headers: authHeader() });
    return response.data;
  },
  async getProductItems(productId) {
    const response = await axios.get(`${API_URL}/productItem/product/${productId}`, { headers: authHeader() });
    return response.data;
  },
  async getCategories() {
    const response = await axios.get(`${API_URL}/categories`, { headers: authHeader() });
    return response.data;
  },
  async getBrands() {
    const response = await axios.get(`${API_URL}/brands`, { headers: authHeader() });
    return response.data;
  },
  async getAttributeGroups() {
    const response = await axios.get(`${API_URL}/attributesGroup`, { headers: authHeader() });
    return response.data;
  },
  async getAttributeValues(groupId) {
    const response = await axios.get(`${API_URL}/attributesValue/attributeGroup/${groupId}`, { headers: authHeader() });
    return response.data;
  },
  async createAttributeValue(attributeValueDTO) {
    const response = await axios.post(`${API_URL}/attributesValue`, attributeValueDTO, { headers: authHeader() });
    return response.data;
  },
  async updateAttributeValue(id, attributeValueDTO) {
    const response = await axios.put(`${API_URL}/attributesValue/${id}`, attributeValueDTO, { headers: authHeader() });
    return response.data;
  },
  async deleteAttributeValue(id) {
    const response = await axios.delete(`${API_URL}/attributesValue/${id}`, { headers: authHeader() });
    return response.data;
  },
  async createAttributeGroup(attributeGroupDTO) {
    const response = await axios.post(`${API_URL}/attributesGroup`, attributeGroupDTO, { headers: authHeader() });
    return response.data;
  },
  async updateAttributeGroup(id, attributeGroupDTO) {
    const response = await axios.put(`${API_URL}/attributesGroup/${id}`, attributeGroupDTO, { headers: authHeader() });
    return response.data;
  },
  async getItemImages(itemId) {
    const response = await axios.get(`${API_URL}/productItems/${itemId}/images`, { headers: authHeader() });
    return response.data;
  },
  async getCommonImage(productId, attributeValueId, coverOrder) {
    const response = await axios.get(`${API_URL}/products/${productId}/commonImage?attributeValueId=${attributeValueId}&coverOrder=${coverOrder}`, { headers: authHeader() });
    return response.data;
  },
  async uploadItemPhoto(itemId, file, coverOrder) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API_URL}/productItems/${itemId}/insertPhoto?coverOrder=${coverOrder}`, formData, {
      headers: {
        ...authHeader(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },
  async uploadItemPhotoByUrl(itemId, url, coverOrder) {
    const response = await axios.post(`${API_URL}/productItems/${itemId}/insertPhotoByUrl?coverOrder=${coverOrder}`, url, {
      headers: {
        ...authHeader(),
        'Content-Type': 'text/plain'
      }
    });
    return response.data;
  },
  async uploadPhotoByAttributeGroup(productId, attributeGroupId, file, coverOrder) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API_URL}/products/${productId}/attributeGroup/${attributeGroupId}/insertPhoto?coverOrder=${coverOrder}`, formData, {
      headers: {
        ...authHeader(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },
  async uploadPhotoByAttributeGroupByUrl(productId, attributeGroupId, url, coverOrder) {
    const response = await axios.post(`${API_URL}/products/${productId}/attributeGroup/${attributeGroupId}/insertPhotoByUrl?coverOrder=${coverOrder}`, url, {
      headers: {
        ...authHeader(),
        'Content-Type': 'text/plain'
      }
    });
    return response.data;
  },
  async createProduct(productDTO) {
    const response = await axios.post(`${API_URL}/products`, productDTO, { headers: authHeader() });
    return response.data;
  },
  async updateProduct(id, productDTO) {
    const response = await axios.put(`${API_URL}/product/${id}`, productDTO, { headers: authHeader() });
    return response.data;
  },
  async updateProductItem(id, itemDTO) {
    const response = await axios.put(`${API_URL}/productItem/${id}`, itemDTO, { headers: authHeader() });
    return response.data;
  },
  async deleteProduct(id) {
    const response = await axios.delete(`${API_URL}/product/${id}`, { headers: authHeader() });
    return response.data;
  }
}
